import { ApiClient } from '@/services/http/apiClient';
import type { ApiResponse, Client } from '@/types/api';

export interface ClientCreatePayload {
  name: string;
  email?: string | null;
  phone?: string | null;
  street?: string | null;
  number?: string | null;
  complement?: string | null;
  city?: string | null;
  state?: string | null;
  zip_code?: string | null;
  country?: string | null;
  notes?: string | null;
  metadata?: Record<string, unknown> | null;
}

export const ClientService = {
  // Público
  async create(data: ClientCreatePayload): Promise<Client> {
    const response = await ApiClient.post<ApiResponse<{ client: Client }>>('/clients', { body: data });
    if (!response.success) {
      throw new Error(response.message || 'Erro ao cadastrar cliente');
    }
    return response.data.client;
  },

  // Admin
  admin: {
    async list(): Promise<Client[]> {
      const response = await ApiClient.get<ApiResponse<{ clients: { data: Client[]; total: number; current_page: number; per_page: number } }>>('/admin/clients');
      if (!response.success) {
        throw new Error(response.message || 'Erro ao listar clientes');
      }
      return response.data.clients.data;
    },
    async show(id: number): Promise<Client> {
      const response = await ApiClient.get<ApiResponse<{ client: Client }>>(`/admin/clients/${id}`);
      if (!response.success) {
        throw new Error(response.message || 'Erro ao buscar cliente');
      }
      return response.data.client;
    },
    async update(id: number, data: Partial<Client>) {
      const response = await ApiClient.put<ApiResponse<{ client: Client }>>(`/admin/clients/${id}`, { body: data });
      if (!response.success) {
        throw new Error(response.message || 'Erro ao atualizar cliente');
      }
      return response.data.client;
    },
    async delete(id: number) {
      const response = await ApiClient.delete<ApiResponse<null>>(`/admin/clients/${id}`);
      if (!response.success) {
        throw new Error(response.message || 'Erro ao remover cliente');
      }
      return response;
    },
  },
};